import getEnv from '@settings/getEnv';
import { createHttpLink } from 'apollo-link-http';

const { REACT_APP_GRAPHQL_SERVER } = getEnv();

export const Link = createHttpLink({
  uri: REACT_APP_GRAPHQL_SERVER,
  fetch,
});
